import { NEWBUILDING_MARTECH_TEST_TGB_INSTEAD_PARALLAX_EXPERIMENT } from '../selectors/experiments/selectIsNewbuildingMartechTestTgbInsteadParallaxGroupParallax';

export const NB_CHAT_COMMON_FILTER = 'newbuilding_chat_common_filter';
export const NB_CONSULTANT_TRIGGERING_MESSAGE = 'newbuilding-triggering-message';
export const NB_HELP_IN_SEARCH = 'newbuilding_consultant_help_in_search';
export const RENTER_FORM_EXPERIMENT = 'renter_form_experiment';
export const PERSONAL_RANKING = 'aud_desktop_cd178510_ranking_v3';
export const AA_TEST_50 = 'aud_desktop_aud2904_split_50_listing_aa_expf';
export const AA_TEST_30 = 'aud_desktop_aud2904_split_30_listing_aa_expf';
export const NEWBUILDING_AA_TEST_50 = 'newbuiliding_test_for_expf_desktop_50_50';
export const NEWBUILDING_AA_TEST_30 = 'newbuiliding_test_for_expf_desktop_70_30';
export const WEB_TO_APP_BANNER = 'aud_desktop_aud2918_qr_banner_web_to_app';
export const AUD_DESKTOP_AUD2776_CIAN_ASSISTANT_ENTRY_POINT = 'aud_desktop_aud2776_cian_assistant_entry_point';

export const EXPERIMENTS: string[] = [
  'newbuilding_consultant',
  NB_CHAT_COMMON_FILTER,
  NB_CONSULTANT_TRIGGERING_MESSAGE,
  NB_HELP_IN_SEARCH,
  /**
   * @todo Удалить строку с экспериментом
   * @description Данный функционал появился в задаче CD-206852, будет удалён в задаче CD-200835
   */
  NEWBUILDING_MARTECH_TEST_TGB_INSTEAD_PARALLAX_EXPERIMENT,
  RENTER_FORM_EXPERIMENT,
  PERSONAL_RANKING,
  AA_TEST_50,
  AA_TEST_30,
  NEWBUILDING_AA_TEST_50,
  NEWBUILDING_AA_TEST_30,
  WEB_TO_APP_BANNER,
  AUD_DESKTOP_AUD2776_CIAN_ASSISTANT_ENTRY_POINT,
];
